/**
 * Vietmap base styles; `{apikey}` is replaced with the key in use. Kept out of
 * App.tsx so pages that only need the URLs don't pull in the whole editor.
 */
export const VIETMAP_STYLE_URLS: Record<string, string> = {
  "vietmap-street": "https://maps.vietmap.vn/maps/styles/tm/style.json?apikey={apikey}",
  "vietmap-light":  "https://maps.vietmap.vn/maps/styles/lm/style.json?apikey={apikey}",
  "vietmap-dark":   "https://maps.vietmap.vn/maps/styles/dm/style.json?apikey={apikey}",
  "vietmap-hybrid": "https://maps.vietmap.vn/maps/styles/hm/style.json?apikey={apikey}",
};
